<nz-page-header nzBackIcon (nzOnBack)="goBack()" [nzTitle]="'Bulk Upload Details'"></nz-page-header>

<div class="page-container" *ngIf="bulkUpload">

	<!-- SUMMARY CARD -->
	<nz-card nzTitle="Summary" class="mb-3">
		<div nz-row nzGutter="16">
			<div nz-col nzSpan="6"><strong>Created At:</strong><br />{{ bulkUpload.createdAt | date:'medium' }}</div>
			<div nz-col nzSpan="6"><strong>Type:</strong><br />{{ bulkUpload.type }}</div>
			<div nz-col nzSpan="6">
				<strong>Status:</strong><br />
				<nz-tag [nzColor]="statusColor(bulkUpload.status)">{{ bulkUpload.status }}</nz-tag>
			</div>
			<div nz-col nzSpan="6"><strong>Agent:</strong><br />{{ bulkUpload.agent?.firstName }}
				{{ bulkUpload.agent?.lastName }}</div>
		</div>

		<div nz-row nzGutter="16" class="mt-2">
			<div nz-col nzSpan="6"><strong>Inserted:</strong> {{ bulkUpload.insertCount }}</div>
			<div nz-col nzSpan="6"><strong>Updated:</strong> {{ bulkUpload.updateCount }}</div>
			<div nz-col nzSpan="6"><strong>Invalid:</strong> {{ bulkUpload.invalidCount }}</div>
			<div nz-col nzSpan="6"><strong>Failed:</strong> {{ bulkUpload.failedCount }}</div>
		</div>
	</nz-card>

	<!-- FILE TABS -->
	<nz-tabset nzType="card" (nzSelectedIndexChange)="onTab($event)" *ngIf="currentFileRows">
		<nz-tab *ngFor="let file of bulkUpload.files; let i = index" [nzTitle]="file.name">
			<div class="settings-bar">
				<label nz-checkbox [(ngModel)]="showOnlyFailed" (ngModelChange)="loadFileData()">
					Show only failed
				</label>

				<label nz-checkbox [(ngModel)]="showOnlyMapped" (ngModelChange)="loadFileData()">
					Show only mapped columns
				</label>
			</div>
			<nz-table
				nzBordered
				nzSize="small"
				[nzData]="currentFileRows!.list"
				[nzFrontPagination]="false"
				[nzTotal]="currentFileRows!.totalItems"
				[nzPageSize]="currentFileRows!.pageSize"
				[nzPageIndex]="currentFileRows!.pageIndex"
				(nzPageIndexChange)="onPageChange($event)"
				(nzPageSizeChange)="onPageSizeChange($event)">
				<thead>
					<tr>
						<th>#</th>
						<ng-container *ngFor="let cell of currentFileRows.list[0].columns">
							<th *ngIf="showOnlyMapped == false || cell.propertyId != null">{{ cell.name }}</th>
						</ng-container>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of currentFileRows!.list" [ngClass]="getRowStyle(row)">
						<td>{{row.lineNumber}}</td>
						<ng-container *ngFor="let cell of row.columns">
							<td *ngIf="showOnlyMapped == false || cell.propertyId != null" [ngClass]="getCellStyle(cell)">
								<ng-container *ngIf="cell.valid || cell.propertyId == undefined">
									<ng-container [ngSwitch]="cell.value">
										<small *ngSwitchCase="'[NULL]'" style="font-size: 0.50em;">NULL</small>
										<span *ngSwitchCase="'[EMPTY]'" style="font-size: 0.50em;">EMPTY</span>
										<span *ngSwitchDefault>{{cell.value}}</span>
									</ng-container>
								</ng-container>
								<ng-container *ngIf="!cell.valid && cell.propertyId != undefined">
									<ng-container [ngSwitch]="cell.value">
										<small *ngSwitchCase="'[NULL]'" style="font-size: 0.50em;">NULL</small>
										<span *ngSwitchCase="'[EMPTY]'" style="font-size: 0.50em;">EMPTY</span>
										<span *ngSwitchDefault>{{cell.value}}</span>
									</ng-container>
								</ng-container>
							</td>
						</ng-container>
					</tr>
				</tbody>
			</nz-table>
		</nz-tab>
	</nz-tabset>
</div>
